import { z } from 'zod';

// The envelope every message between the theme builder and its storefront preview wears. A page's other
// frame traffic never carries this channel, so nothing else is ever mistaken for an editor message.

/** Stamped on every editor message, so a page's other frame traffic is never mistaken for one. */
export const THEME_EDITOR_CHANNEL = 'xshop-theme-editor';

/** The query key that puts the storefront in editor mode, and the one naming the theme being edited. */
export const THEME_EDITOR_FLAG = 'editor';
export const THEME_EDITOR_THEME = 'editorTheme';

// Builds the three fields every editor message opens with: the channel, who sent it, and what it is.
export const editorEnvelope = <T extends string, F extends string>(from: F, type: T) => ({
  channel: z.literal(THEME_EDITOR_CHANNEL),
  from: z.literal(from),
  type: z.literal(type)
});
